import Action from './Action';

export class SubmittedAction extends Action {
  constructor(params) {
    super({ ...params, actionName: 'SUBMITTED_STATE' });
  }
}
